import Vue from 'vue';
const resource = '/workorderitems';

export default {
  // CUSTOM ENDPOINT
  getByWorkOrder(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `workorders/${idPublic}${resource}`
    );
  },
  getByWorkOrderWithWorkOrderItemOrderItems(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `workorders/${idPublic}${resource}?include=workorderitemorderitems`
    );
  },
  getByWorkOrderAndItem(workOrderIdPublic, itemIdPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `${resource}?workorderidpublic=${workOrderIdPublic}&itemidpublic=${itemIdPublic}`
    );
  },
  getRequestedByItem(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `items/${idPublic}${resource}/requested`
    );
  },
  getReservedByItem(idPublic) {
    return Vue.prototype.$axiosMainClient.get(
      `items/${idPublic}${resource}/reserved`
    );
  },
  getRequested() {
    return Vue.prototype.$axiosMainClient.get(`${resource}/requested`);
  },
  getReserved() {
    return Vue.prototype.$axiosMainClient.get(`${resource}/reserved`);
  },
};
